module.exports = __webpack_public_path__ + "static/media/Pontem3.12fa011c.png";